<template>

  <div class="col-container-card-annonce-home col-12">
    <div :class="{'placeholder-gradient': isGradient, 'placeholder-animated': isAnimated}"
         class="placeholder-card-annonce">
    </div>
  </div>

</template>

<script>

export default {
  name: 'PlaceholderCardAlerts',

  props: {
    customDisplayClass: {
      default: "",
      required: false
    },
    isGradient: {
      required: true
    },
    isAnimated: {
      required: true
    },

  },

  computed: {},

}

</script>

<style scoped>

.placeholder-card-annonce {
  border-radius: var(--fourth-border-radius);
  background-color: var(--main-black-medium);
  height: calc(70px + 10px + 10px);
}

.placeholder-card-annonce.placeholder-gradient {
  background-image: var(--linear-gradient-main-black-medium);
}

.placeholder-animated {
  background: var(--linear-gradient-main-black-medium-animated);
  background-size: 400% 400%;

  animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
  -webkit-animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
  -moz-animation: var(--place-holder-annonce-card-animation) 9s ease infinite;
}

.col-container-card-annonce-home {
  padding-left: 0.5em;
  padding-bottom: 0.5em;
  padding-right: 0px;
}

</style>



// WEBPACK FOOTER //
// src/views/user/PlaceholderCardAlerts.vue